import { refreshToken } from '../../../middlewares/renew-ks';
import { RhinoError, RhinoErrorCode } from '../../error';

import { ExperienceApiResponse } from './type';

export function handleExperienceErrors<Payload>(response: ExperienceApiResponse<Payload>) {
  if (!response.errors) {
    return;
  }

  const error = response.errors[0];

  if (!error) {
    return;
  }

  const { code: phoenixCode } = error.extensions.phoenix;
  const context = { nativeError: error };
  let code: RhinoErrorCode = 'NETWORK_API_ERROR';

  if (phoenixCode === '500015') {
    code = 'INVALID_KS';

    refreshToken();
  }

  if (phoenixCode === '500016') {
    code = 'EXPIRED_KS';

    refreshToken();
  }

  throw new RhinoError(code, undefined, context);
}
